// extracted by mini-css-extract-plugin
export default {"TotalCasesProcessedPortletStub":"index__TotalCasesProcessedPortletStub__tscUx"};